import { render, staticRenderFns } from "./rights.vue?vue&type=template&id=205de67d&scoped=true"
import script from "./rights.vue?vue&type=script&lang=ts"
export * from "./rights.vue?vue&type=script&lang=ts"
import style0 from "./rights.vue?vue&type=style&index=0&id=205de67d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205de67d",
  null
  
)

export default component.exports